import { useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs({ pageType }) {
  const location = useLocation();
  return (
    <div className="mt-1 mb-1" sx={{ padding: "0px !important" }}>
      <div>
        <span className="breadcrumb-not-active ">Masters </span>{" "}
        <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
        <span className="breadcrumb-not-active ">MOQ Approve {pageType} </span>
      </div>
    </div>
  );
}
export default Breadcrumbs;
